import React from 'react'
import { Link } from 'react-router-dom'

import styled from 'styled-components'
import { mobile } from '../responsive'

const Container = styled.div`
    width: 100%;
    height: 88vh;
    display: flex;

    ${mobile({ flexDirection: "column" })}
`

const Left = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    ${mobile({ width: "100%" })}
`

const Right = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    ${mobile({ width: "100%", marginLeft: "5%" })}
`

const Toneri = styled.div`
    width: 90%;
    height: 90%;
    position: relative;
`

const Boje = styled.div`
    width: 90%;
    height: 43%;
    margin-bottom: 2%;
    position: relative;
`

const Dijelovi = styled.div`
    width: 90%;
    height: 45%;
    position: relative;
`

const Slika = styled.img`
    border-radius: 20px;
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const Apsolute = styled.p`
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 34px;
    color: white;
    text-shadow: 1px 3px black;
`

const Categories = () => {
  return (
    <Container>
        <Left>
            <Toneri>
                <Link to="/canon">
                    <Slika src="https://cdn1.productnation.co/stg/sites/5/61dfe2a38c77b.jpeg" />
                    <Apsolute>Canon Toneri</Apsolute>
                </Link>
            </Toneri>
        </Left>

        <Right>
            <Boje>
                <Link to="/hp">
                    <Slika src="https://blueshieldonline.com/wp-content/uploads/2020/03/hp301color.jpg" />
                    <Apsolute>HP Toneri</Apsolute>
                </Link>
            </Boje>

            <Dijelovi>
                <Link to="/ostali">
                    <Slika src="https://4.imimg.com/data4/FK/SF/MY-3916769/printer-spares-parts-500x500.jpg" />
                    <Apsolute>Svi Brendovi</Apsolute>
                </Link>
            </Dijelovi>
        </Right>
    </Container>
  )
}

export default Categories